import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
  faBox,
  faTrophy,
  faStar,
  faGem,
  faFire,
  faBolt,
  faShieldHalved,
  faShieldHeart,
  faCrown,
  faHandshake,
  faMedal,
  faGift,
  faFish,
  faChartLine,
  faScaleBalanced,
  faHeart,
  faUsers,
  faRocket,
  faClock,
  faEnvelope,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';

const BADGE_ICON_MAP: Record<string, IconDefinition> = {
  package: faBox,
  trophy: faTrophy,
  star: faStar,
  gem: faGem,
  fire: faFire,
  bolt: faBolt,
  shield: faShieldHalved,
  'shield-check': faShieldHeart,
  crown: faCrown,
  handshake: faHandshake,
  medal: faMedal,
  gift: faGift,
  whale: faFish,
  chart: faChartLine,
  scale: faScaleBalanced,
  heart: faHeart,
  users: faUsers,
  rocket: faRocket,
  clock: faClock,
  envelope: faEnvelope,
  check: faCircleCheck,
};

export const getIconForSlug = (slug: string): IconDefinition => {
  return BADGE_ICON_MAP[slug] || faMedal;
};
